/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: AbstractPrecompiledNameFactory.ts
 * Project: mle-client-n
 * Committed last: 2022/11/25 @ 1110
 * ---
 * Description:
 */

import {PrecompiledBaseInput} from "./AbstractPrecompiledFactory";

/**
 * Factory generica per la creazione dei nomi univoci dei precompilati
 */
export abstract class AbstractPrecompiledNameFactory<T extends PrecompiledBaseInput> {

    /**
     * Calcola il nome di un precompilato sulla base dei suoi dati
     * @param data
     */
    abstract calculateName(data: T): string

    /**
     * Calcola i nomi di più precompilati sulla base dei loro dati
     * @param data
     */
    calculateNames(data: T[]): string[] {
        return data.map(it => this.calculateName(it));
    }
}